<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      title="订单明细"
      id-key="RecordId"
      :data="data"
      :save-func="() => {}"
      form-label-width="85px"
      @details-opened="onDetailsOpened"
      @closed="onClosed"
    >
      <template slot="form">
        <el-descriptions>
          <el-descriptions-item label="订单编号">
            <span
              v-clipboard:copy="data.OrderNo"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              {{ data.OrderNo }}<i class="el-icon-copy-document"></i></span
          ></el-descriptions-item>
          <el-descriptions-item label="下单时间">{{
            data.OrderDate
          }}</el-descriptions-item>
          <!-- <el-descriptions-item label="所属商家">{{
            data.StoreName
          }}</el-descriptions-item> -->
        </el-descriptions>
        <el-row class="row-border" style="padding: 0">
          <el-table :data="OrderInfos" style="width: 98%; margin: 0 auto">
            <el-table-column label="收货信息">
              <template slot-scope="{ row }">
                <div style="text-align: left" v-if="data.OrderMode==0">
                  <span>收货人：{{ row.ReceivingPerson }}</span
                  ><br />
                  <span>联系电话：{{ row.ReceivingPhone }}</span
                  ><br />
                  <span>收货地址：{{ row.ReceivingAddress }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="买家信息">
              <template slot-scope="{ row }">
                <div style="text-align: left">
                  <span>买家：{{ row.NickName }}</span
                  ><br />
                  <!-- <span>{{ row.PersonCode }}</span
                  ><br /> -->
                  <span>买家留言：{{ row.Remark }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="付款信息">
              <template slot-scope="{ row }">
                <div style="text-align: left">
                  <span v-if="row.PayType == 0">付款方式：微信支付<br /></span>
                  <span
                    >实付金额：{{
                      Number(row.PayAmount || 0).toFixed(2)
                    }}
                    元</span
                  ><br />
                  <span
                    >优惠金额：{{
                      Number(row.CouponAmount ?? 0).toFixed(2)
                    }}
                    元</span
                  ><br />
                  <span
                    v-clipboard:copy="data.OrderNo"
                    v-clipboard:success="copySuccess"
                    v-clipboard:error="copyError"
                    >支付凭证：{{ row.PayNo }}
                    <i class="el-icon-copy-document"></i
                  ></span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="配送信息">
              <template slot-scope="{ row }">
                <div style="text-align: left"  v-if="data.OrderMode==0">
                  <span v-if="row.ExpressMode == 2">配送方式：自提<br /></span>
                  <span v-else>配送方式：物流配送<br /></span>
                  <span>配送时间：{{ row.SendDate }} </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-row>

        订单日志
        <el-row class="row-border" style="padding-right: 0; padding-top: 10px">
          <el-col :span="24" style="padding: 10px">
            <el-steps :active="OrderLog.length">
              <el-step
                icon="el-icon-circle-check"
                v-for="item in OrderLog"
                :key="item.RecordId"
                :title="item.Action"
                :description="item.AddTime"
              ></el-step>
            </el-steps>
          </el-col>
        </el-row>
        <div v-if="data.OrderMode==0">物流信息
        <el-row class="row-border" style="padding: 10px">
          <el-col :span="8">
            <!-- <span v-if="data.PayType == 1">发货方式：自提<br /></span> -->
            <span>发货方式：物流配送<br /></span>
            发货时间： {{ data.SendDate }}<br />
            物流企业：{{ data.ExpressCompanyName }}<br />
            物流单号：{{ data.ExpressNo }}
          </el-col>
          <el-col :span="16">
            <span>物流状态：{{ Logistics.logisticsStatusDesc }}</span>
            <div class="infinite-list" style="overflow: auto; margin-top: 10px">
              <el-timeline :reverse="false">
                <el-timeline-item
                  v-for="(activity, index) in Logistics.fullTraceDetail"
                  :key="index"
                  :timestamp="activity.time"
                >
                  {{ activity.desc }}
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-col>
        </el-row>
        <br /></div>
        商品明细
        <el-row style="padding-top: 5px">
          <el-col :span="24">
            <el-table border :data="OrderGoods" size="mini">
              <el-table-column
                prop="GoodsName"
                label="商品信息"
                width="400px"
                align="center"
              >
                <template slot-scope="{ row }">
                  <el-row style="text-align: left">
                    <el-col :span="6">
                      <el-image
                        ref="img"
                        :src="'/api' + row.GoodsCover"
                        style="width: 80px"
                    /></el-col>
                    <el-col :span="18">
                      {{ row.GoodsName }}<br />
                      规格：{{ row.AttributeName }}<br />
                      货号：{{ row.AttributeCode }}</el-col
                    >
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column prop="PlatformPrice" label="单价" align="center">
                <template slot-scope="{ row }">
                  {{ Number(row.PlatformPrice || 0).toFixed(2) }}
                </template></el-table-column
              >
              <el-table-column
                prop="MainunitCount"
                label="数量"
                align="center"
              />
              <el-table-column prop="ActivityPrice" label="优惠" align="center">
                <template slot-scope="{ row }">
                  {{
                    row.activity_id > 0
                      ? Number(
                          row.ActivityPrice - row.PlatformPrice || 0
                        ).toFixed(2)
                      : Number(
                          row.PlatformPrice - row.PlatformPrice || 0
                        ).toFixed(2)
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="SumAmount" label="小计" align="center">
                <template slot-scope="{ row }">
                  {{ Number(row.SumAmount || 0).toFixed(2) }}
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20" :xs="6">
            <div style="width: 100%; height: 100px"></div>
          </el-col>
          <el-col :span="4" :xs="18" style="text-align: right; padding: 10px 0">
            <table style="width: 100%">
              <tr>
                <td>商品金额：</td>
                <td>¥{{ Number(data.GoodsAmount || 0).toFixed(2) }}</td>
              </tr>
              <tr>
                <td>运费金额：</td>
                <td>
                  ¥{{ Number(data.RealityExpressamount || 0).toFixed(2) }}
                </td>
              </tr>
              <tr>
                <td>优惠金额：</td>
                <td>
                  -¥{{ Number(data.SubTotal - data.PayAmount || 0).toFixed(2) }}
                </td>
              </tr>
              <tr>
                <td>订单总额：</td>
                <td>¥{{ Number(data.SubTotal || 0).toFixed(2) }}</td>
              </tr>
              <tr>
                <td>实付金额：</td>
                <td>¥{{ Number(data.PayAmount || 0).toFixed(2) }}</td>
              </tr>
              <tr v-if="data.OrderState == 5">
                <td>发货状态：</td>
                <td>
                  <span v-if="data.SendState == 1">待发货</span>
                  <span v-if="data.SendState == 2">待收货</span>
                  <span v-if="data.SendState == 3">已完成</span>
                </td>
              </tr>
              <tr v-if="data.OrderState == 6">
                <td>取消状态：</td>
                <td>
                  <span v-if="data.CancelState == 1">待付款取消</span>
                  <span v-if="data.CancelState == 2">待发货取消</span>
                  <span v-if="data.CancelState == 3">待收货取消</span>
                  <span v-if="data.CancelState == 4">已收货取消</span>
                </td>
              </tr>
            </table>
          </el-col>
        </el-row>
        <!-- 订单内容
        <el-row class="row-border">
          <el-row>
            <el-col :span="8">
              <el-form-item label="订单编号">
                <span>{{data.OrderNo}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单时间">
                <span>{{this.$commonJs.toDateString(data.OrderDate)}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="用户名称">
                <span>{{data.PersonName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="联系人">
                <span>{{data.ReceivingPerson}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话">
                <span>{{data.ReceivingPhone}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="收货地址">
                <span>{{data.ReceivingAddress}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>           
            <el-col :span="8">
              <el-form-item label="优惠券">
                <span>{{data.CouponName}}</span>
              </el-form-item>
            </el-col> <el-col :span="8">
              <el-form-item label="优惠活动">
                <span v-if="data.ActivityType==0">团购</span>
                <span v-if="data.ActivityType==1">秒杀</span>
                <span v-if="data.ActivityType==2">折扣</span>
                <span v-if="data.ActivityType==3">满送</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="优惠券金额">
                <span>{{data.CouponAmount}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="商品金额">
                <span>{{data.GoodsAmount}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="配送金额">
                <span>{{data.RealityExpressamount}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="优惠后金额">
                <span>{{data.PayAmount}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="订单总额">
                <span>{{data.SubTotal}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="配送方式">
                <span>{{data.ExpressModeText}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单状态">
                <span>{{data.OrderStateText}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="发货状态">
                <span>{{data.SendStateText}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="付款状态">
                <span>{{data.PayStateText}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="退款状态">
                <span>{{data.RefundStateText}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品信息">
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-table border :data="OrderGoods" style="margin:-10px 0 15px 15px;" size="mini">
                <el-table-column prop="GoodsName" label="商品名称" />
                <el-table-column prop="AttributeName" label="规格型号" />
                <el-table-column prop="MainUnitName" label="单位" />
                <el-table-column prop="PlatformPrice" label="单价" />
                <el-table-column prop="ActivityPrice" label="优惠后单价" >
                  <template slot-scope="{ row }">
                      {{row.activity_id>0?row.ActivityPrice:row.PlatformPrice}}
                  </template>  
                </el-table-column>    
                <el-table-column prop="MainunitCount" label="数量" />
                <el-table-column prop="SumAmount" label="金额" />
              </el-table>
            </el-col>
          </el-row>
        </el-row> -->
        <!-- 发货信息
        <el-row> -->
        <!-- <el-col :span="12">
            <el-form-item label="配送公司">
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="配送单号">
            </el-form-item>
          </el-col> -->
        <!-- <el-col :span="24">
            <el-table border :data="DeliverList" style="margin-top: 10px; margin-bottom:10px">
              <el-table-column prop="DocTime" label="发货日期"></el-table-column>
              <el-table-column prop="DocNo" label="发货单号"></el-table-column>
              <el-table-column prop="CompanyName" label="配送公司"></el-table-column>
              <el-table-column prop="ExpressNo" label="配送单号"></el-table-column>
            </el-table>
          </el-col>
        </el-row> -->
      </template>
      <template slot="footer">
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [detailsDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OrderNo: "", //订单编号
        CustomerId: null, //客户编号
        CustomerName: "", //客户名称
        Mobile: "", //手机号
        CustomerType: null, //客户类型 - 1:零售
        GoodsAmount: null, //商品金额
        Quantity: null, //商品数量
        Amount: null, //订单金额
        PayAmount: null, //实付金额
        Point: null, //积分
        AddTime: null, //订单时间
        OrderState: null, //订单状态 - 0:未确认 1:正常执行中 2:退款中 3:已完成 4:已取消
        OrderStateText: "",
        SendState: null, //发货状态 - 0:未发货 1:已发货 2:已收货 3:退货中 4:退货待收 5:已退货
        SendStateText: "",
        PayState: null, //付款状态 - 0:未付款 1:已付款 2:退款中 3:已退款
        PayStateText: "",
        RefundAmount: 0, //退款金额
        RefundState: null, //退款状态 - 0:无 1:退款待审 2:客户取消 3:同意退款 4:拒绝退款
        RefundStateText: "",
        FreightMode: null, //配送方式 - 0:异地配送 1:本地配送 2:自提
        ExpressName: "", //配送公司
        ExpressNo: "", //配送单号
        Freight: null, //配送金额
        SubTotal: null, //小计金额
        CouponName: "", //优惠券名称
        CouponAmount: null, //优惠金额
        Person: "", //收货联系人
        Phone: "", //收货联系电话
        Address: "", //收货地址
        Reason: "", //退款原因
        ApplyTime: null, //退款申请时间
        Feedback: "", //商家反馈
        Remark: "", //商家备注
        BackExpressName: "", //退货配送公司
        BackExpressNo: "", //退货配送单号
        BackTime: null, //退货时间
      },
      OrderGoods: [], //商品信息
      OrderLog: [], //操作日志
      DeliverList: [], //发货信息
      RefundList: [], //退货商品
      Logistics: [], //物流信息
      api: require("@/api/sale/order/order").default,
      ogApi: require("@/api/sale/order/orderGoods").default,
      olApi: require("@/api/sale/order/orderLog").default,
      rgApi: require("@/api/sale/order/returnGoods").default,
      OrderInfos: [],
    };
  },
  methods: {
    copySuccess() {
      this.$message.success("复制成功");
    },
    copyError() {
      this.$message.error("复制失败");
    },
    onDetailsOpened(data) {
      var params = { OrdermainId: this.data.RecordId };
      this.api.getOrderInfo(this.data.RecordId).then((res) => {
        if (res.Data) {
          this.data = res.Data;
          this.OrderInfos.push(res.Data);
        }
      });

      this.ogApi.list(params).then((res) => {
        if (res.Data) {
          this.OrderGoods = res.Data;
          this.OrderGoods.sort(
            (a, b) => a.AttributeOrderId - b.AttributeOrderId
          );
        }
      });
      this.olApi.list(params).then((res) => {
        if (res.Data) this.OrderLog = res.Data;
      });
      this.api.getDeliverDocList(this.data.RecordId).then((res) => {
        if (res.Data) this.DeliverList = res.Data;
      });
      this.api.getOrderLogistics(this.data.RecordId).then((res) => {
        if (res.Data) this.Logistics = res.Data;
      });
      if (data.RefundStatus > 0) {
        this.rgApi.list(params).then((res) => {
          if (res.Data) this.RefundList = res.Data;
        });
      }
    },
    onClosed() {
      this.OrderGoods = [];
      this.OrderLog = [];
      this.DeliverList = [];
      this.RefundList = [];
      this.OrderInfos = [];
      this.Logistics = [];
    },
  },
};
</script>
<style>
.el-descriptions--mini {
  font-size: 14px;
}
.el-descriptions__header {
  margin-bottom: 0;
}
.infinite-list {
  height: 100px;
}
</style>